<template>
  <div class="container">
    <slot v-if="!isLoading"></slot>
    <BLoading :active.sync="isLoading" />
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  name: 'GlobalView',
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    ...mapState(['auth', 'properties', 'featureFlags']),
  },
  watch: {
    $route: 'checkRedirect',
    '$route.fullPath': 'checkRedirect',
    'properties.propertiesById': 'checkRedirect',
    'auth.user.customer.is_customer_lead': 'checkRedirect',
    'auth.user.customer.processing_order.property_info.completed_at': 'checkRedirect',
    'auth.user.customer.processing_order.distribute_early': 'checkRedirect',
    'featureFlags.flags': 'checkRedirect',
  },
  created() {
    this.checkRedirect();
  },
  methods: {
    checkRedirect() {
      const { customer } = this.auth.user;

      if (this.featureFlags && !this.featureFlags.flags['customerWebRedesign:signupIntegration']) {
        if (!customer.processing_order && !customer.is_customer_lead) {
          return this.navigateToNewWeb();
        }

        const schedules = _.get(Object.values(this.properties.propertiesById)[0], 'schedules');

        const conditions = [
          this.$route.fullPath.includes('onboarding'),
          this.$route.matched.some((record) => record.meta.isOnboarding),
          customer.is_customer_lead,
          !_.get(customer.processing_order, 'property_info.completed_at', true),
          _.get(customer.processing_order, 'distribute_early', null) === null,
          !_.isUndefined(schedules) && _.isEmpty(schedules),
        ];

        if (conditions.some((condition) => condition)) {
          return (this.isLoading = false);
        }

        return this.navigateToNewWeb();
      }

      if (this.featureFlags) {
        this.isLoading = false;
      }
    },

    navigateToNewWeb() {
      let redirectUrl = `${process.env.VUE_APP_NEW_BASE_URL}?auth=${this.auth.token}`;
      if (window.location.pathname && window.location.pathname !== '/') {
        redirectUrl += `&intent=${window.location.pathname}`;
      }

      window.location.assign(redirectUrl);
    },
  },
};
</script>
